import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandsDot',
  standalone: true,
})
export class ThousandsDotPipe implements PipeTransform {
  transform(value: number): string {
    if (value === null || value === undefined) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
}
